var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRegularProviderMarkerSelected = function SvgRegularProviderMarkerSelected(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 38,
    viewBox: "0 0 27 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6559_39409)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2412,
    cy: 34.1205,
    rx: 6.47456,
    ry: 2.25505,
    fill: "black",
    fillOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2412 32.8337C13.6326 32.8336 14.0069 32.6774 14.2822 32.4012C14.5133 32.1696 17.1802 29.4668 19.7965 25.9031C21.1046 24.1213 22.4159 22.1032 23.4035 20.0547C24.385 18.0192 25.0847 15.8771 25.0847 13.8676C25.0847 6.38315 19.0434 1.91724 13.241 1.91724C7.43867 1.91724 1.39734 6.38315 1.39734 13.8676C1.39734 15.8771 2.09706 18.0192 3.07848 20.0547C4.06617 22.1032 5.3774 24.1213 6.68554 25.9031C9.29948 29.4635 11.9639 32.1647 12.1992 32.4005C12.4746 32.6772 12.8491 32.8336 13.2408 32.8337H13.2412Z",
    fill: "#417091",
    stroke: "#417091",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5605 12.6089C17.5605 15.0116 15.624 16.9547 13.241 16.9547C10.8581 16.9547 8.92163 15.0116 8.92163 12.6089C8.92163 10.2063 10.8581 8.26318 13.241 8.26318C15.624 8.26318 17.5605 10.2063 17.5605 12.6089Z",
    fill: "white",
    stroke: "#417091"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6559_39409",
    x: 5.7666,
    y: 30.8655,
    width: 14.9491,
    height: 6.51001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_6559_39409"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRegularProviderMarkerSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/regular-provider-marker-selected.f01dc34ece07961b2d4a363211ca423a.svg";